import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from "react";
import { connect } from "react-redux";
import Moment from "moment";
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from "react-datepicker";
import sv from 'date-fns/locale/sv';
import no from 'date-fns/locale/nb';
import en from 'date-fns/locale/en-US';
import da from "date-fns/locale/da";
import uk from "date-fns/locale/uk";
import { Select, translate, getActiveLanguage } from "@haldor/ui";
var DatePickers = /*#__PURE__*/function (_Component) {
  function DatePickers(props) {
    var _this;
    _classCallCheck(this, DatePickers);
    _this = _callSuper(this, DatePickers, [props]);
    _defineProperty(_this, "onStartChange", function (time) {
      var _this$state = _this.state,
        dtPickerStartDate = _this$state.dtPickerStartDate,
        startDate = _this$state.startDate;
      if (time != "Invalid date" && time != null) {
        dtPickerStartDate = Moment(time);
        startDate = Moment(time).format("YYYY-MM-DD");
        _this.setState({
          dtPickerStartDate: dtPickerStartDate,
          startDate: startDate
        }, function () {
          _this.onChange();
        });
      } else {
        var dStartDate = Moment();
        var _startDate2 = Moment().format("YYYY-MM-DD");
        var dDueDate = Moment();
        var dueDate = Moment().format("YYYY-MM-DD");
        _this.setState({
          dtPickerStartDate: dStartDate,
          dtPickerDueDate: dDueDate,
          startDate: _startDate2,
          endDate: dueDate
        });
      }
    });
    _defineProperty(_this, "getDateFormat", function () {
      var format = Moment.localeData(getActiveLanguage()).longDateFormat("L");
      var newFormat = format.replace("YYYY", "yyyy");
      var days = newFormat.replace("DD", "dd");
      return days;
    });
    _defineProperty(_this, "onEndChange", function (time) {
      var _this$state2 = _this.state,
        dtPickerDueDate = _this$state2.dtPickerDueDate,
        endDate = _this$state2.endDate;
      if (time != "Invalid date" && time != null) {
        dtPickerDueDate = Moment(time);
        endDate = Moment(time).format("YYYY-MM-DD");
        _this.setState({
          dtPickerDueDate: dtPickerDueDate,
          endDate: endDate
        }, function () {
          _this.onChange();
        });
      } else {
        var dDueDate = Moment();
        var dueDate = Moment().format("YYYY-MM-DD");
        _this.setState({
          dtPickerDueDate: dDueDate,
          endDate: dueDate
        }, function () {
          _this.onChange();
        });
      }
    });
    _defineProperty(_this, "onTermChange", function (value) {
      if (value != "") {
        var dStartDate = Moment();
        var startDate = Moment().format("YYYY-MM-DD");
        var dDueDate = Moment();
        var dueDate = Moment().format("YYYY-MM-DD");
        switch (value) {
          case "year":
            if (Moment().month() < 7) {
              dStartDate = Moment().subtract(1, "year").month(7).date(1);
              startDate = Moment().subtract(1, "year").month(7).date(1).format("YYYY-MM-DD");
              dDueDate = Moment().month(6).date(31);
              dueDate = Moment().month(6).date(31).format("YYYY-MM-DD");
            } else {
              dStartDate = Moment().month(7).date(1);
              startDate = Moment().month(7).date(1).format("YYYY-MM-DD");
              dDueDate = Moment().add(1, "year").month(6).date(31);
              dueDate = Moment().add(1, "year").month(6).date(31).format("YYYY-MM-DD");
            }
            break;
          case 'previous-year':
            if (Moment().month() < 7) {
              dStartDate = Moment().subtract(2, 'year').month(7).date(1);
              startDate = Moment().subtract(2, 'year').month(7).date(1).format('YYYY-MM-DD');
              dDueDate = Moment().subtract(1, 'year').month(6).date(31);
              dueDate = Moment().subtract(1, 'year').month(6).date(31).format('YYYY-MM-DD');
            } else {
              dStartDate = Moment().subtract(1, 'year').month(7).date(1);
              startDate = Moment().subtract(1, 'year').month(7).date(1).format('YYYY-MM-DD');
              dDueDate = Moment().subtract(0, 'year').month(6).date(31);
              dueDate = Moment().subtract(0, 'year').month(6).date(31).format('YYYY-MM-DD');
            }
            break;
          case "semester":
            if (Moment().month() < 7) {
              dStartDate = Moment().month(0).date(1);
              startDate = Moment().month(0).date(1).format("YYYY-MM-DD");
              dDueDate = Moment().month(6).date(31);
              dueDate = Moment().month(6).date(31).format("YYYY-MM-DD");
            } else {
              dStartDate = Moment().month(6).date(1);
              startDate = Moment().month(6).date(1).format("YYYY-MM-DD");
              dDueDate = Moment().month(11).date(31);
              dueDate = Moment().month(11).date(31).format("YYYY-MM-DD");
            }
            break;
        }
        _this.setState({
          dtPickerStartDate: dStartDate,
          dtPickerDueDate: dDueDate,
          startDate: startDate,
          endDate: dueDate
        }, function () {
          _this.onChange();
        });
      }
    });
    _defineProperty(_this, "onChange", function () {
      if (_this.props.onChange) {
        var dates = {
          start: _this.state.startDate,
          end: _this.state.endDate
        };
        _this.props.onChange(dates);
      }
    });
    Moment.locale(getActiveLanguage());
    registerLocale('en-US', en);
    registerLocale('sv-SE', sv);
    registerLocale('nb-NO', no);
    registerLocale('da-DK', da);
    registerLocale('uk', uk);
    setDefaultLocale('en-US');
    var _dStartDate;
    var _dDueDate;
    var _startDate;
    var _dueDate;
    if (props.startDate != null) {
      _dStartDate = Moment(props.startDate);
      _startDate = props.startDate;
    } else {
      _dStartDate = Moment();
      _startDate = Moment().format("YYYY-MM-DD");
    }
    if (props.endDate != null) {
      _dDueDate = Moment(props.endDate);
      _dueDate = props.endDate;
    } else {
      _dDueDate = Moment();
      _dueDate = Moment().format("YYYY-MM-DD");
    }
    _this.state = {
      dtPickerStartDate: _dStartDate,
      dtPickerDueDate: _dDueDate,
      startDate: _startDate,
      endDate: _dueDate
    };
    return _this;
  }
  _inherits(DatePickers, _Component);
  return _createClass(DatePickers, [{
    key: "render",
    value: function render() {
      var translate = this.props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row-half static"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "date-start",
        style: {
          marginTop: 0
        }
      }, translate("Start")), /*#__PURE__*/React.createElement(DatePicker, {
        selected: this.state.dtPickerStartDate.toDate(),
        startDate: this.state.dtPickerStartDate.toDate(),
        endDate: this.state.dtPickerDueDate.toDate(),
        onChange: this.onStartChange,
        selectsStart: true,
        popperPlacement: "bottom-start",
        showWeekNumbers: true,
        fixedHeight: true,
        dateFormat: this.getDateFormat(),
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: "",
        locale: getActiveLanguage()
      })), /*#__PURE__*/React.createElement("div", {
        className: "form-row-half static last"
      }, /*#__PURE__*/React.createElement("label", {
        htmlFor: "date-end",
        style: {
          marginTop: 0
        }
      }, translate("End")), /*#__PURE__*/React.createElement(DatePicker, {
        selected: this.state.dtPickerDueDate.toDate(),
        startDate: this.state.dtPickerStartDate.toDate(),
        endDate: this.state.dtPickerDueDate.toDate(),
        minDate: this.state.dtPickerStartDate.toDate(),
        onChange: this.onEndChange,
        popperPlacement: "bottom-start",
        selectsEnd: true,
        dateFormat: this.getDateFormat(),
        showWeekNumbers: true,
        fixedHeight: true,
        previousMonthButtonLabel: "",
        nextMonthButtonLabel: "",
        isClearable: true,
        locale: getActiveLanguage()
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          display: "inline-block"
        }
      }, /*#__PURE__*/React.createElement(Select, {
        onChange: this.onTermChange,
        options: [{
          label: translate("Current school year"),
          value: "year"
        }, {
          label: this.props.translate('Previous schoolyear'),
          value: 'previous-year'
        }, {
          label: translate("Current semester"),
          value: "semester"
        }]
      }, translate("Select period")))));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps)(DatePickers);